import Task from './container/index';

export default Task;


// WEBPACK FOOTER //
// ./src/views/Task/index.js